import React from "react";
import { assetUrl } from "@/lib/glossyApi";
import Markdown from "@/components/Markdown";
import { Reveal } from "@/components/Reveal";

const CAPTIONS = {
  venue: "Inside the space",
  action: "At work",
  product: "The details",
  detail: "The details",
  scenery: "The neighbourhood",
  portrait: "The owner",
  original: "From the business",
};

function Figure({ shot, alt }) {
  const [portrait, setPortrait] = React.useState(false);
  const src = assetUrl(shot.image);
  if (!src) return null;
  return (
    <Reveal>
      <figure className="my-12 sm:my-16">
        <div className={`relative overflow-hidden bg-ink ed-frame ${portrait ? "" : "aspect-[3/2]"}`}>
          <img
            src={src}
            alt={alt}
            onLoad={(e) => { if (e.target.naturalHeight > e.target.naturalWidth) setPortrait(true); }}
            className={portrait ? "w-auto max-h-[85vh] mx-auto block ed-grade" : "w-full h-full object-cover ed-grade"}
            data-testid="article-spread-image"
          />
        </div>
        <figcaption className="font-mono text-[11px] uppercase tracking-[0.25em] text-ink/45 mt-3">
          {CAPTIONS[shot.slug] || "S/ME"} — {alt}
        </figcaption>
      </figure>
    </Reveal>
  );
}

// Interleaves a varied image set (venue/action/product/scenery) through the body,
// splitting at ## subheadings for a true magazine-spread rhythm.
export default function ArticleSpread({ body, gallery = [], title = "", accent = "" }) {
  const chunks = (body || "").split(/\n(?=## )/);
  return (
    <div data-testid="article-spread">
      {chunks.map((chunk, i) => (
        <React.Fragment key={i}>
          <div className="max-w-[760px] mx-auto">
            <Reveal>
              <Markdown text={chunk} accent={accent} />
            </Reveal>
          </div>
          {gallery[i] && (
            <div className="max-w-[1080px] mx-auto px-0">
              <Figure shot={gallery[i]} alt={title} />
            </div>
          )}
        </React.Fragment>
      ))}
      {/* any remaining images beyond the number of sections */}
      {gallery.length > chunks.length && (
        <div className="max-w-[1080px] mx-auto grid grid-cols-1 sm:grid-cols-2 gap-6">
          {gallery.slice(chunks.length).map((shot, i) => (
            <Figure key={i} shot={shot} alt={title} />
          ))}
        </div>
      )}
    </div>
  );
}
